'use strict';

angular.module('linagora.esn.controlcenter')

  .component('controlcenterSidebar', {
    template: require('./sidebar.pug')
  });
